// extracted by mini-css-extract-plugin
module.exports = {"statsBlock":"style-module__statsBlock___2SZKO","stats":"style-module__stats___3eZes"};